module.exports = __webpack_public_path__ + "static/molten-de-chocolate-con-helado-de-chocolate-blanco-1-2cc50a5f199cbeadff65691fe6f37e55.jpg";